import React, {useState} from 'react';
import {makeStyles} from '@material-ui/styles';
import {
  Button,
  // Divider,
  Grid,
  Hidden,
  withStyles,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
// import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import PriceToStr from '../../../_components/PriceToStr';
import clsx from 'clsx';
import {useTranslation} from 'react-i18next';
import Box from '@material-ui/core/Box';
import BasketAdd from '../../../icons/BasketAdd';
import StyledBadgeOne from '../../../_components/StyledBadgeOne';
import {
  Planet as PlanetIcon,
  Shield as ShieldIcon,
  Timer as TimerIcon,
} from '../../../icons';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Tooltip from '@material-ui/core/Tooltip';

import expectedDate from '../../../images/expected_date_icon_1-01.svg';
import moment from 'moment';
import RadioButtonUnchecked from '@material-ui/core/SvgIcon/SvgIcon';
import {connect} from 'react-redux';

import DiscountModal from '../../../views/ProductList/components/DiscountModal/DiscountModal';

import IconDiscount from '../../../images/icon_discount.svg';
import StarRatings from 'react-star-ratings';

const useStyles = makeStyles(theme => ({
  product_buy_block: {
    [theme.breakpoints.down('md')]: {},
    [theme.breakpoints.down('sm')]: {},
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 26,
    '& h1': {},
    '& p': {
      margin: 0,
      color: '#606060',
      fontSize: 18,
    },

    [theme.breakpoints.down('md')]: {
      marginBottom: 10,
    },
  },
  desc: {
    marginBottom: 40,
    fontSize: 14,

    [theme.breakpoints.down('md')]: {
      marginBottom: 10,
    },
  },
  producer: {
    marginBottom: 10,
    fontSize: 14,
    '& span': {
      color: '#7a7a7a',
    },

    [theme.breakpoints.down('md')]: {
      marginBottom: 8,
    },

    [theme.breakpoints.down('sm')]: {
      marginBottom: 15,
    },
  },
  existence: {
    // marginBottom: 15,

    [theme.breakpoints.down('md')]: {
      marginBottom: 12,
    },

    '& > p': {
      margin: '0 0 6px 0',
      // color: '#7a7a7a'
    },
    '& ul': {
      listStyle: 'none',
      padding: 0,
      margin: 0,
    },
    '& li': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      lineHeight: '1.6',
    },
    '& .MuiListItemText-root': {},
    '& .MuiListItem-secondaryAction': {
      paddingBottom: 0,
      paddingTop: 0,
    },
    '& li p': {},
  },
  footer: {},
  product_price_container: {
    paddingBottom: 8,
  },
  totalTitle: {
    margin: 0,
    color: '#92d36e',
  },
  product_input_container: {
    '& .MuiGrid-container': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  totalPrice: {
    margin: 0,
    display: 'inline-grid',
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
      lineHeight: '28px',
    },
  },
  input: {
    width: '100%',

    '& input': {
      padding: '10px 5px 10px 10px',
      [theme.breakpoints.down('md')]: {
        fontSize: 14,
        padding: '8px 5px 8px 10px',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 14,
        padding: '10px 5px 10px 10px',
      },
    },
  },
  button: {
    [theme.breakpoints.down('md')]: {
      // width: "100%",
      // padding: "2px 16px",
    },
    [theme.breakpoints.up('md')]: {
      // padding: "4px 16px",
    },
    [theme.breakpoints.up('lg')]: {
      // padding: "6px 16px",
      // display: "block",
      // marginLeft: "auto",
      // marginRight: 0,
    },
  },
  iconButton: {
    [theme.breakpoints.down('md')]: {},
    [theme.breakpoints.up('md')]: {},
    [theme.breakpoints.up('lg')]: {},
  },

  other_customer_price: {
    background: '#F2F2F2',
    borderRadius: '4px',
    padding: '5px',
    width: '150px',
    marginTop: '3px',
  },

  regularPriceHolder: {
    display: 'block',

    '& em': {
      display: 'block',
      // width: '100%',
    },
  },

  list_other_customer_price: {
    width: 270,
    listStile: 'none',
    margin: 0,
    padding: 0,
    '& li': {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 0 5px',
    },
  },

  expected_dateBlock: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },

  expected_date_img_holder: {
    width: '200px',
    position: 'relative',

    '& img': {
      height: '20px',
    },
  },

  stBlockDeliveryRadioOrange: {
    fontSize: 12,
    borderRadius: '50%',
    backgroundColor: 'orange',
    color: 'orange',
    margin: '0 0 0 10px',
  },

  discounts_by_product_block: {
    background: '#e8e8e8',
    borderRadius: '5px',
    width: '98%',
    cursor: 'pointer',
  },

  discounts_by_product_caption: {
    // background: "#e8e8e8",
    // borderTop: "1px solid #fff",
    // borderRadius: "5px 5px 0 0",
    color: '#008CB4',
    display: 'flex',
    alignItems: 'center',
    // justifyContent:"space-between",
    justifyContent: 'center',
    padding: '5px 10px',
    fontSize: '18px',

    '& img': {
      width: '28px',
      margin: '0 10px 0 0',
    },
  },

  discounts_by_product_content: {
    fontSize: '14px',
    // background: "#e8e8e8",
    // borderRadius: "0 0 5px 5px",
    fontWeight: '600',
    '& li': {
      padding: '5px 16px',
      lineHeight: 1,
    },
  },

  slash: {
    margin: '0 5px',
  },
}));

function Details(props) {
  const {
    // cartAll,
    setDialogData,
    // currencyMainContr,
    result,
    currencyMain,
    promotionsByProductsList,
  } = props;

  const {t} = useTranslation();

  const classes = useStyles();
  // const [allStockNull, setAllStockNull] = React.useState(true);
  const [checkOtherCustomersList, setCheckOtherCustomersList] = useState([]);
  const [discountsModal, setDiscountsModal] = useState(false);

  let otherCustomersList = [];

  React.useEffect(() => {
    if (result.on_stock.length > 0) {
      //productData.on_stock.sort((a, b) => (a.customer_warehouse - b.customer_warehouse) * (-1));
      result.on_stock.sort(
        (a, b) => (a.customer_warehouse - b.customer_warehouse) * -1,
      );
    }
  }, [result]);

  React.useEffect(() => {
    otherCustomerMinPrice();
    setCheckOtherCustomersList(otherCustomersList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const [otherCustomerPriceGroup, setOtherCustomerPriceGroup] = useState('');

  if (!result.on_stock && result.on_stock.length === 0)
    return <React.Fragment />;
  /*productData.on_stock.map((item) => {
        item.priceCurrent = item.res_price_all_valutes[abbr].price_discount;
        item.regularPrice = item.res_price_all_valutes[abbr].regular_price;
        return true;
    });
    productData.isDiscount = 0;
    if (productData.on_stock[0].priceCurrent !== productData.on_stock[0].regularPrice) {
        productData.isDiscount = Math.round((productData.on_stock[0].regularPrice - productData.on_stock[0].priceCurrent) / productData.on_stock[0].regularPrice * (100));
    }*/
  const row = {
    brand: result.article.brand,
    brand_clean: result.article.brand_clean,
    brand_orig_clean: result.article.brand_clean,
    article: result.article.article,
    article_clean: result.article.article_clean,
    article_orig_clean: result.article.article_clean,
    images: {
      thumb: result.article.photo.thumb,
      // gallery: result.article.photo.gallery_photos,
      // art: result.article.photo.art_photos,
      // large: result.article.photo.large_photos,
      // mobile: result.article.photo.mobile_photos,
    },
    //balance: result.on_stock,
    //balance: result.on_stock,
    price: result.on_stock[0].price,
    /*priceCurrent: currencyMain && currencyMain.simbol === "₴"
            ? Math.round(result.on_stock[0].price * currencyMainContr.koef)
            : result.on_stock[0].price * currencyMainContr.koef,*/
    priceCurrent: result.on_stock[0].priceCurrent,
    name: result.article.name,
    product_id: result.article.product_id,
  };
  if (
    promotionsByProductsList &&
    promotionsByProductsList[row.product_id] !== undefined
  )
    row.promoLabel = promotionsByProductsList[row.product_id];
  if (result.isRequest === 1) row.offers = result.on_stock;
  else row.balance = result.on_stock;

  let guarantees = [];
  guarantees['Дн'] = t('common:warranty_d');
  guarantees['Мес'] = t('common:warranty_m');
  guarantees['Г'] = t('common:warranty_y');

  const HtmlTooltip = withStyles(theme => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',

      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }))(Tooltip);

  const otherCustomerMinPrice = () => {
    if (result.prices_by_customer.other_customers.length > 0) {

      result.prices_by_customer.other_customers.map((el, index) => {
        if (
          el.discount_group__id !== 84 &&
          el.discount_group__id !== 81 &&
          el.discount_group__id !== 87 &&
          el.discount_group__id !== 78 &&
          el.discount_group__id !==
            result.prices_by_customer.current_customer.discount_group__id
        ) {
          otherCustomersList.push(el);
        }
        return otherCustomersList;
      });
      let minPriceOtherCustomerArr = [];
      let minPriceOtherCustomer;
      let minPriceOtherCustomerName;
      if (otherCustomersList.length > 0) {
        otherCustomersList.map((el, index) => {
          return minPriceOtherCustomerArr.push(
            el.currency_of_contract_price.price_discount,
          );
        });

        minPriceOtherCustomer = Math.min(...minPriceOtherCustomerArr);
        minPriceOtherCustomerName = otherCustomersList.filter(
          otherCustomersList =>
            otherCustomersList.currency_of_contract_price.price_discount ===
            minPriceOtherCustomer,
        );
        let parsePriceGroup = minPriceOtherCustomerName[0].discount_group__name.split(
          ';',
        );

        return (
          <>
            <div style={{lineHeight: '1', fontSize: '13px', color: '#606060'}}>
              {parsePriceGroup[1]}:
            </div>
            <PriceToStr
              stSumma={{
                fontSize: '13px',
                fontStyle: 'normal',
                color: '#606060',
              }}
              data={minPriceOtherCustomer}
              beforeText={''}
              text={
                otherCustomersList[0] &&
                otherCustomersList[0].currency_of_contract_price.currency.simbol
                  ? otherCustomersList[0].currency_of_contract_price.currency
                      .simbol
                  : ''
              }
              grn={t('common:uah')}
            />
          </>
        );
      }
    }
  };

  const renderTooltip = () => {
    let findRepeatDiscountGroupId = result.prices_by_customer.other_customers;
    if (findRepeatDiscountGroupId.length > 0) {
      let current_customer_discount_group_id =
        result.prices_by_customer.current_customer.discount_group__id;
      let resultMinPrice = [];
      let minPrice = 0;
      let saveCustomerMinPrice;
      let unique = [];
      let g = [];
      let repeatDiscountGroupIdPrice = [];

      findRepeatDiscountGroupId.map((el, index) => {
        if (el.discount_group__id !== current_customer_discount_group_id) {
          g.push(el.discount_group__id);
        }
        return true;
      });

      let h = g.reduce((x, y) => (x.includes(y) ? x : [...x, y]), []);

      h.map((el, index) => {
        unique.push(
          findRepeatDiscountGroupId.filter(
            findRepeatDiscountGroupId =>
              findRepeatDiscountGroupId.discount_group__id === el,
          ),
        );
        return true;
      });

      unique.map((el, index) => {
        repeatDiscountGroupIdPrice = [];
        el.map((elem, index) => {
          repeatDiscountGroupIdPrice.push(
            elem.current_currency_price.price_discount,
          );
          minPrice = Math.min(...repeatDiscountGroupIdPrice);
          return true;
        });

        saveCustomerMinPrice = el.filter(
          el => el.current_currency_price.price_discount === minPrice,
        );

        resultMinPrice.push({
          price:
            saveCustomerMinPrice[0].currency_of_contract_price.price_discount,
          name: saveCustomerMinPrice[0].discount_group__name,
          currency_of_contract: saveCustomerMinPrice[0].currency_of_contract,
          currency_of_contract_price:
            saveCustomerMinPrice[0].currency_of_contract_price.currency.simbol,
          discount_group__id: saveCustomerMinPrice[0].discount_group__id,
        });

        return true;
      });

      return (
        <ul className={classes.list_other_customer_price}>
          <li>
            <span>
              {result.prices_by_customer.current_customer.discount_group__name}
            </span>
            <span>
              <span style={{margin: '0 5px 0 0'}}>
                {result.prices_by_customer.current_customer.currency_of_contract_price.price_discount.toFixed(
                  2,
                )}
              </span>
              <span>
                {result.prices_by_customer.current_customer
                  .currency_of_contract === 'UAH'
                  ? t('common:uah')
                  : result.prices_by_customer.current_customer
                      .currency_of_contract_price.currency.simbol}
              </span>
            </span>
          </li>
          {resultMinPrice.map((elem, index) => (
            <li key={elem.name + index}>
              <span>{elem.name}</span>
              <span>
                <span style={{margin: '0 5px 0 0'}}>
                  {elem.price.toFixed(2)}
                </span>
                <span>
                  {elem.currency_of_contract === 'UAH'
                    ? t('common:uah')
                    : elem.currency_of_contract_price}
                </span>
              </span>
            </li>
          ))}

          {findRepeatDiscountGroupId.map((el, index) => (
            <>
              {el.discount_group__id !== current_customer_discount_group_id &&
              el.discount_group__id !== resultMinPrice[0].discount_group__id &&
              el.discount_group__id !== resultMinPrice[1].discount_group__id ? (
                <li key={index} color="inherit">
                  <span>{el.discount_group__name}</span>
                  <span>
                    <span style={{margin: '0 5px 0 0'}}>
                      {el.currency_of_contract_price.price_discount.toFixed(2)}
                    </span>
                    <span>
                      <span>
                        {el.currency_of_contract === 'UAH'
                          ? t('common:uah')
                          : el.currency_of_contract_price.currency.simbol}
                      </span>
                    </span>
                  </span>
                </li>
              ) : null}
            </>
          ))}
        </ul>
      );
    }
  };

  const discounts_by_quantity_sum_of_order =
    result.on_stock[0].discounts_by_quantity_sum_of_order;

  return (
    <div className={clsx(classes.product_buy_block, 'product_buy_block')}>
      <div>
        <div className="single-product-flex mb-3">
          <h2 className="single-product-title">
            {result.article?.brand}
            <span className="single-product-like"></span>
          </h2>
          <div className="single-product-code">{result.article.article}</div>
        </div>

        <div className="single-product-flex">
          <p className="single-product-desc col-md-8">{result.article.name}</p>
          <div className="single-product-stars col-md-4">
            <StarRatings
              rating={5}
              starDimension="19px"
              starSpacing="2.25px"
              starRatedColor="#FFBE00"
            />
            26 відгуків
          </div>
        </div>
        <div className="single-product-btns">
          <button className="btn btn-single-product">
            <svg
              width="13"
              height="16"
              viewBox="0 0 13 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1 6.83333C1 3.625 3.625 1 6.83333 1C10.0417 1 12.6667 3.625 12.6667 6.83333C12.6667 11.15 7.35833 14.7667 7.18333 14.8833C7.06667 14.9417 6.95 15 6.83333 15C6.71667 15 6.6 14.9417 6.48333 14.8833C6.30833 14.7667 1 11.15 1 6.83333ZM2.16699 6.83268C2.16699 9.98268 5.72533 12.8993 6.83366 13.716C7.94199 12.8993 11.5003 9.98268 11.5003 6.83268C11.5003 4.26602 9.40033 2.16602 6.83366 2.16602C4.26699 2.16602 2.16699 4.26602 2.16699 6.83268ZM6.83333 4.5C5.55 4.5 4.5 5.55 4.5 6.83333C4.5 8.11667 5.55 9.16667 6.83333 9.16667C8.11667 9.16667 9.16667 8.11667 9.16667 6.83333C9.16667 5.55 8.11667 4.5 6.83333 4.5ZM5.66699 6.83268C5.66699 7.47435 6.19199 7.99935 6.83366 7.99935C7.47533 7.99935 8.00033 7.47435 8.00033 6.83268C8.00033 6.19102 7.47533 5.66602 6.83366 5.66602C6.19199 5.66602 5.66699 6.19102 5.66699 6.83268Z"
                fill="#414D5F"
              />
              <path
                d="M7.18333 14.8833L7.2284 14.9735L7.2388 14.9665L7.18333 14.8833ZM6.48333 14.8833L6.42743 14.9672L6.43861 14.9728L6.48333 14.8833ZM6.83366 13.716L6.77434 13.7965L6.83366 13.8402L6.89298 13.7965L6.83366 13.716ZM6.83333 0.9C3.56977 0.9 0.9 3.56977 0.9 6.83333H1.1C1.1 3.68023 3.68023 1.1 6.83333 1.1V0.9ZM12.7667 6.83333C12.7667 3.56977 10.0969 0.9 6.83333 0.9V1.1C9.98644 1.1 12.5667 3.68023 12.5667 6.83333H12.7667ZM7.2388 14.9665C7.32971 14.9059 8.70765 13.9676 10.064 12.5012C11.4176 11.0379 12.7667 9.0306 12.7667 6.83333H12.5667C12.5667 8.95273 11.2616 10.9121 9.91721 12.3654C8.57569 13.8157 7.21196 14.7441 7.12786 14.8001L7.2388 14.9665ZM6.83333 15.1C6.9782 15.1 7.11719 15.0282 7.22805 14.9728L7.13861 14.7939C7.01614 14.8551 6.9218 14.9 6.83333 14.9V15.1ZM6.43861 14.9728C6.54947 15.0282 6.68847 15.1 6.83333 15.1V14.9C6.74487 14.9 6.65053 14.8551 6.52805 14.7939L6.43861 14.9728ZM0.9 6.83333C0.9 9.0306 2.24906 11.0379 3.60263 12.5012C4.95902 13.9676 6.33696 14.9059 6.42786 14.9665L6.5388 14.8001C6.45471 14.7441 5.09098 13.8157 3.74945 12.3654C2.40511 10.9121 1.1 8.95273 1.1 6.83333H0.9ZM6.89298 13.6355C6.34229 13.2297 5.18244 12.3017 4.1613 11.0851C3.138 9.86581 2.26699 8.37201 2.26699 6.83268H2.06699C2.06699 8.44336 2.97515 9.98289 4.0081 11.2136C5.04321 12.447 6.2167 13.3856 6.77434 13.7965L6.89298 13.6355ZM11.4003 6.83268C11.4003 8.37201 10.5293 9.86581 9.50602 11.0851C8.48488 12.3017 7.32503 13.2297 6.77434 13.6355L6.89298 13.7965C7.45062 13.3856 8.6241 12.447 9.65921 11.2136C10.6922 9.98289 11.6003 8.44336 11.6003 6.83268H11.4003ZM6.83366 2.26602C9.3451 2.26602 11.4003 4.32124 11.4003 6.83268H11.6003C11.6003 4.21079 9.45555 2.06602 6.83366 2.06602V2.26602ZM2.26699 6.83268C2.26699 4.32124 4.32222 2.26602 6.83366 2.26602V2.06602C4.21176 2.06602 2.06699 4.21079 2.06699 6.83268H2.26699ZM4.6 6.83333C4.6 5.60523 5.60523 4.6 6.83333 4.6V4.4C5.49477 4.4 4.4 5.49477 4.4 6.83333H4.6ZM6.83333 9.06667C5.60523 9.06667 4.6 8.06144 4.6 6.83333H4.4C4.4 8.1719 5.49477 9.26667 6.83333 9.26667V9.06667ZM9.06667 6.83333C9.06667 8.06144 8.06144 9.06667 6.83333 9.06667V9.26667C8.1719 9.26667 9.26667 8.1719 9.26667 6.83333H9.06667ZM6.83333 4.6C8.06144 4.6 9.06667 5.60523 9.06667 6.83333H9.26667C9.26667 5.49477 8.1719 4.4 6.83333 4.4V4.6ZM6.83366 7.89935C6.24722 7.89935 5.76699 7.41912 5.76699 6.83268H5.56699C5.56699 7.52958 6.13676 8.09935 6.83366 8.09935V7.89935ZM7.90033 6.83268C7.90033 7.41912 7.4201 7.89935 6.83366 7.89935V8.09935C7.53055 8.09935 8.10033 7.52958 8.10033 6.83268H7.90033ZM6.83366 5.76602C7.4201 5.76602 7.90033 6.24624 7.90033 6.83268H8.10033C8.10033 6.13579 7.53055 5.56602 6.83366 5.56602V5.76602ZM5.76699 6.83268C5.76699 6.24624 6.24722 5.76602 6.83366 5.76602V5.56602C6.13676 5.56602 5.56699 6.13579 5.56699 6.83268H5.76699Z"
                fill="#414D5F"
              />
            </svg>
            {t('common:Country')}: {result.article.brands_country}
          </button>
          <button className="btn btn-single-product">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15 8V7.42727C15 7.04545 14.7455 6.79091 14.3636 6.79091C13.9818 6.79091 13.7273 7.04545 13.7273 7.42727V8C13.7273 11.1818 11.1818 13.7273 8 13.7273C4.81818 13.7273 2.27273 11.1818 2.27273 8C2.27273 4.81818 4.81818 2.27273 8 2.27273C8.82727 2.27273 9.59091 2.46364 10.3545 2.78182C10.6727 2.90909 11.0545 2.78182 11.1818 2.46364C11.3091 2.14545 11.1818 1.76364 10.8636 1.63636C9.97273 1.19091 8.95455 1 8 1C4.11818 1 1 4.11818 1 8C1 11.8818 4.11818 15 8 15C11.8818 15 15 11.8818 15 8ZM14.5546 1.82763C14.8091 1.57308 15.191 1.57308 15.4455 1.82763C15.7 2.08217 15.7 2.46399 15.4455 2.71854L8.4455 9.71854C8.31823 9.84581 8.12732 9.90945 8.00004 9.90945C7.87277 9.90945 7.68186 9.84581 7.55459 9.71854L5.6455 7.80945C5.39095 7.5549 5.39095 7.17308 5.6455 6.91854C5.90004 6.66399 6.28186 6.66399 6.53641 6.91854L8.00004 8.38217L14.5546 1.82763Z"
                fill="#414D5F"
              />
              <path
                d="M10.3545 2.78182L10.3161 2.87414L10.3174 2.87467L10.3545 2.78182ZM11.1818 2.46364L11.089 2.4265L11.1818 2.46364ZM10.8636 1.63636L10.8188 1.72612L10.8265 1.72921L10.8636 1.63636ZM15.4455 1.82763L15.5162 1.75692L15.4455 1.82763ZM14.5546 1.82763L14.6253 1.89834L14.5546 1.82763ZM15.4455 2.71854L15.5162 2.78925L15.4455 2.71854ZM8.4455 9.71854L8.37479 9.64783L8.4455 9.71854ZM7.55459 9.71854L7.48388 9.78925L7.55459 9.71854ZM5.6455 7.80945L5.57479 7.88016L5.6455 7.80945ZM6.53641 6.91854L6.4657 6.98925L6.53641 6.91854ZM8.00004 8.38217L7.92933 8.45288L8.00004 8.52359L8.07076 8.45288L8.00004 8.38217ZM14.9 7.42727V8H15.1V7.42727H14.9ZM14.3636 6.89091C14.5318 6.89091 14.6642 6.94653 14.7543 7.03662C14.8444 7.12671 14.9 7.25909 14.9 7.42727H15.1C15.1 7.21364 15.0284 7.02784 14.8957 6.8952C14.7631 6.76256 14.5773 6.69091 14.3636 6.69091V6.89091ZM13.8273 7.42727C13.8273 7.25909 13.8829 7.12671 13.973 7.03662C14.0631 6.94653 14.1955 6.89091 14.3636 6.89091V6.69091C14.15 6.69091 13.9642 6.76256 13.8316 6.8952C13.6989 7.02784 13.6273 7.21364 13.6273 7.42727H13.8273ZM13.8273 8V7.42727H13.6273V8H13.8273ZM8 13.8273C11.237 13.8273 13.8273 11.237 13.8273 8H13.6273C13.6273 11.1266 11.1266 13.6273 8 13.6273V13.8273ZM2.17273 8C2.17273 11.237 4.76295 13.8273 8 13.8273V13.6273C4.87341 13.6273 2.37273 11.1266 2.37273 8H2.17273ZM8 2.17273C4.76295 2.17273 2.17273 4.76295 2.17273 8H2.37273C2.37273 4.87341 4.87341 2.37273 8 2.37273V2.17273ZM10.393 2.68951C9.6203 2.36755 8.84347 2.17273 8 2.17273V2.37273C8.81107 2.37273 9.56152 2.55972 10.3161 2.87413L10.393 2.68951ZM11.089 2.4265C10.9857 2.68455 10.6679 2.79946 10.3917 2.68897L10.3174 2.87467C10.6775 3.01872 11.1233 2.87908 11.2747 2.50078L11.089 2.4265ZM10.8265 1.72921C11.0846 1.83243 11.1995 2.15028 11.089 2.4265L11.2747 2.50078C11.4187 2.14063 11.2791 1.69484 10.9008 1.54352L10.8265 1.72921ZM8 1.1C8.94215 1.1 9.94444 1.28857 10.8189 1.72581L10.9084 1.54692C10.001 1.09325 8.96694 0.9 8 0.9V1.1ZM1.1 8C1.1 4.17341 4.17341 1.1 8 1.1V0.9C4.06295 0.9 0.9 4.06295 0.9 8H1.1ZM8 14.9C4.17341 14.9 1.1 11.8266 1.1 8H0.9C0.9 11.937 4.06295 15.1 8 15.1V14.9ZM14.9 8C14.9 11.8266 11.8266 14.9 8 14.9V15.1C11.937 15.1 15.1 11.937 15.1 8H14.9ZM15.5162 1.75692C15.2226 1.46332 14.7775 1.46332 14.4839 1.75692L14.6253 1.89834C14.8408 1.68285 15.1593 1.68285 15.3748 1.89834L15.5162 1.75692ZM15.5162 2.78925C15.8098 2.49565 15.8098 2.05052 15.5162 1.75692L15.3748 1.89834C15.5903 2.11383 15.5903 2.43233 15.3748 2.64783L15.5162 2.78925ZM8.51621 9.78925L15.5162 2.78925L15.3748 2.64783L8.37479 9.64783L8.51621 9.78925ZM8.00004 10.0094C8.15205 10.0094 8.36896 9.9365 8.51621 9.78925L8.37479 9.64783C8.26749 9.75512 8.10258 9.80945 8.00004 9.80945V10.0094ZM7.48388 9.78925C7.63113 9.9365 7.84803 10.0094 8.00004 10.0094V9.80945C7.89751 9.80945 7.73259 9.75512 7.6253 9.64783L7.48388 9.78925ZM5.57479 7.88016L7.48388 9.78925L7.6253 9.64783L5.71621 7.73874L5.57479 7.88016ZM5.57479 6.84783C5.28119 7.14142 5.28119 7.58656 5.57479 7.88016L5.71621 7.73874C5.50072 7.52324 5.50072 7.20474 5.71621 6.98925L5.57479 6.84783ZM6.60712 6.84783C6.31352 6.55423 5.86839 6.55423 5.57479 6.84783L5.71621 6.98925C5.9317 6.77375 6.2502 6.77375 6.4657 6.98925L6.60712 6.84783ZM8.07076 8.31146L6.60712 6.84783L6.4657 6.98925L7.92933 8.45288L8.07076 8.31146ZM14.4839 1.75692L7.92933 8.31146L8.07076 8.45288L14.6253 1.89834L14.4839 1.75692Z"
                fill="#414D5F"
              />
            </svg>
            {t('common:warranty') +
              ': ' +
              result.article.term +
              (guarantees[result.article.guarantees]
                ? guarantees[result.article.guarantees]
                : result.article.guarantees)}
          </button>
          <button className="btn btn-single-product">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z"
                stroke="#414D5F"
                strokeWidth="1.4"
              />
              <path
                d="M7.00049 3.22852V7.47733L9.66136 9.22852"
                stroke="#414D5F"
                strokeWidth="1.2"
              />
            </svg>
            {t('common:Prompt shipment')}
          </button>
        </div>
        <div className="single-product-table mt-3">
          <div className="row">
            <div className=" col-12">
              <ul className="single-product-list">
                {result.on_stock.map(listItem => (
                  <li key={listItem.title}>
                    <span className="title">{listItem.warehouse_name}</span>
                    <span className="count">{listItem.quantity}/ шт</span>
                  </li>
                ))}
              </ul>
            </div>
            {Object.keys(result.on_stock[0].discounts_by_quantity_sum_of_order)
              .length ? (
              <div className="col-md-5 col-12">{"renderList('count')"}</div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      <Hidden smDown>
        <div className="header">
          <Typography variant="h6">{result.article.brand}</Typography>
          <Typography className={'article'} variant="h6">
            {result.article.article}
          </Typography>
        </div>
        <Typography className={'description'}>{result.article.name}</Typography>
      </Hidden>

      <Grid container spacing={2} className={'features_block_container'}>
        <Grid item xs={6} sm={4} md={12}>
          <List disablePadding={true} className={'product_features_list'}>
            <ListItem disableGutters={true}>
              <ListItemIcon>
                <PlanetIcon />
              </ListItemIcon>

              <Hidden only={['xs', 'md', 'lg']}>
                <ListItemText
                  className={'one_line'}
                  primaryTypographyProps={{
                    variant: 'body2',
                  }}
                  primary={
                    t('common:Country') + ': ' + result.article.brands_country
                  }
                />
              </Hidden>

              <Hidden only={['sm']}>
                <ListItemText
                  className={'break_world'}
                  primaryTypographyProps={{
                    variant: 'body2',
                  }}
                  primary={t('common:Country') + ':'}
                  secondaryTypographyProps={{
                    variant: 'body2',
                  }}
                  secondary={result.article.brands_country}
                />
              </Hidden>
            </ListItem>
          </List>
        </Grid>
        <Grid item xs={6} sm={4} md={12}>
          <List disablePadding={true} className={'product_features_list'}>
            <ListItem disableGutters={true}>
              <ListItemIcon>
                <ShieldIcon />
              </ListItemIcon>

              <Hidden only={['xs', 'md', 'lg']}>
                <ListItemText
                  className={'one_line'}
                  primaryTypographyProps={{
                    variant: 'body2',
                  }}
                  primary={
                    t('common:warranty') +
                    ': ' +
                    result.article.term +
                    (guarantees[result.article.guarantees]
                      ? guarantees[result.article.guarantees]
                      : result.article.guarantees)
                  }
                />
              </Hidden>

              <Hidden only={['sm']}>
                <ListItemText
                  className={'break_world'}
                  primaryTypographyProps={{
                    variant: 'body2',
                  }}
                  primary={t('common:warranty') + ':'}
                  secondaryTypographyProps={{
                    variant: 'body2',
                  }}
                  secondary={
                    result.article.term +
                    (guarantees[result.article.guarantees]
                      ? guarantees[result.article.guarantees]
                      : result.article.guarantees)
                  }
                />
              </Hidden>
            </ListItem>
          </List>
        </Grid>
        <Grid item xs={12} sm={4} md={12}>
          <List disablePadding={true} className={'product_features_list'}>
            <ListItem disableGutters={true}>
              <ListItemIcon>
                <TimerIcon />
              </ListItemIcon>
              <Hidden only={['xs', 'md', 'lg']}>
                <ListItemText
                  className={'one_line'}
                  primaryTypographyProps={{
                    variant: 'body2',
                  }}
                  primary={t('common:Prompt shipment')}
                />
              </Hidden>

              <Hidden only={['sm']}>
                <ListItemText
                  className={'break_world'}
                  primaryTypographyProps={{
                    variant: 'body2',
                  }}
                  primary={t('common:Prompt')}
                  secondaryTypographyProps={{
                    variant: 'body2',
                  }}
                  secondary={t('common:shipment')}
                />
              </Hidden>
            </ListItem>
          </List>
        </Grid>
      </Grid>

      {result.on_stock.length > 0 && (
        <div style={{display: 'contents'}}>
          <Grid container className={clsx(classes.existence, 'existence')}>
            <Grid
              item
              md={12}
              xl={
                discounts_by_quantity_sum_of_order !== undefined &&
                discounts_by_quantity_sum_of_order.discounts_by_product !==
                  undefined &&
                discounts_by_quantity_sum_of_order.discounts_by_product
                  .discount_conditions_document__promotion_type !==
                  'NO_CONDITION' &&
                discounts_by_quantity_sum_of_order.discounts_by_product
                  .discount_conditions_document__promotion_type !== ''
                  ? 6
                  : 12
              }>
              <Typography variant="body2">
                {t('common:Availability_in_stock')}:
              </Typography>
              <List className="stock_list">
                {result.on_stock.map((row, index) => (
                  <ListItem
                    disableGutters={true}
                    key={index}
                    style={{padding: '0 5px 0 0'}}>
                    <ListItemText>
                      <Typography variant="h6">{row.warehouse_name}</Typography>
                    </ListItemText>

                    {row.quantity === '0' &&
                    row.expected_date === '0001-01-01' ? (
                      <Typography color={'error'} variant="h6">
                        {row.quantity}
                      </Typography>
                    ) : row.quantity === '0' &&
                      row.expected_date !== '0001-01-01' ? (
                      <div className={classes.expected_dateBlock}>
                        <div
                          className={classes.expected_date_img_holder}
                          style={{
                            width:
                              discounts_by_quantity_sum_of_order.discounts_by_product !==
                              undefined
                                ? '120px'
                                : '200px',
                          }}>
                          <img
                            src={expectedDate}
                            alt=""
                            style={{
                              display: 'block',
                              width: '100%',
                              height: 'auto',
                            }}
                          />
                          <div
                            style={{
                              position: 'absolute',
                              right:
                                discounts_by_quantity_sum_of_order.discounts_by_product !==
                                undefined
                                  ? '0px'
                                  : '10px',
                              top:
                                discounts_by_quantity_sum_of_order.discounts_by_product !==
                                undefined
                                  ? '0px'
                                  : '5px',
                              fontSize: '12px',
                              color: '#606060',
                            }}>
                            {moment(row.expected_date).format('DD.MM.YY')}
                          </div>
                        </div>
                        <RadioButtonUnchecked
                          className={classes.stBlockDeliveryRadioOrange}
                        />
                      </div>
                    ) : (
                      <Typography variant="h6">
                        <Box color="success.main"> {row.quantity}</Box>
                      </Typography>
                    )}
                  </ListItem>
                ))}
                {result.isRequest === 0 &&
                  result.storage_empty.map((row, index) => (
                    <ListItem
                      disableGutters={true}
                      key={index}
                      style={{opacity: 0.7, padding: '0 5px 0 0'}}>
                      <ListItemText>
                        <Typography variant="h6">{row.name}</Typography>
                      </ListItemText>
                      <Typography color={'error'} variant="h6">
                        {'0'}
                      </Typography>
                    </ListItem>
                  ))}
              </List>
            </Grid>
            {discounts_by_quantity_sum_of_order !== undefined &&
              discounts_by_quantity_sum_of_order.discounts_by_product !==
                undefined &&
              discounts_by_quantity_sum_of_order.best_discount
                .discount_conditions_document__promotion_type !== '' && (
                <Grid
                  item
                  md={12}
                  xl={6}
                  style={{display: 'flex', justifyContent: 'end'}}>
                  <>
                    {/*FROM_THE_SUM_OF_ORDER*/}

                    <div
                      className={classes.discounts_by_product_block}
                      onClick={() => setDiscountsModal(true)}>
                      <div className={classes.discounts_by_product_caption}>
                        <img src={IconDiscount} alt={'IconDiscount'} />
                        {t('common:best_price')}
                      </div>
                      <div
                        style={{
                          height: '1px',
                          background: '#fff',
                          width: '85%',
                          margin: '0 auto',
                        }}></div>
                      {discounts_by_quantity_sum_of_order.discounts_by_product.map(
                        (type, index) => (
                          <>
                            {type.promotion_type ===
                            'FROM_THE_QUANTITY_OF_GOODS' ? (
                              <List
                                key={type.promotion_type}
                                className={
                                  classes.discounts_by_product_content
                                }>
                                {type.discounts.map((item, index) => (
                                  <ListItem
                                    key={index}
                                    style={{display: 'flex'}}>
                                    <div>x{item.quantity}</div>
                                    <div
                                      style={{
                                        // width: "115px",
                                        display: 'flex',
                                        // justifyContent: "space-between"
                                      }}>
                                      <PriceToStr
                                        stSumma={{
                                          fontStyle: 'normal',
                                          fontSize: 14,
                                          fontWeight: '600',
                                        }}
                                        stAll={
                                          {
                                            // marginBottom: -3,
                                            // textAlign: 'right',
                                          }
                                        }
                                        data={item.price_with_discount}
                                        beforeText={''}
                                        text={
                                          currencyMain && currencyMain.simbol
                                            ? currencyMain.simbol
                                            : ''
                                        }
                                        grn={t('common:uah')}
                                      />
                                      <span className={classes.slash}>/</span>
                                      <span>{t('common:pieces')}</span>
                                    </div>
                                  </ListItem>
                                ))}
                              </List>
                            ) : type.promotion_type ===
                              'FROM_THE_SUM_OF_ORDER' ? (
                              <React.Fragment key={type.promotion_type}>
                                <div style={{padding: '5px 16px 0px'}}>
                                  {t('common:when_ordering_from')}:
                                </div>
                                <List
                                  className={
                                    classes.discounts_by_product_content
                                  }>
                                  {type.discounts.map((item, index) => (
                                    <ListItem
                                      key={index}
                                      style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                      }}>
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          width: '100%',
                                        }}>
                                        <PriceToStr
                                          stSumma={{
                                            fontStyle: 'normal',
                                            fontSize: 14,
                                            fontWeight: '600',
                                          }}
                                          stAll={
                                            {
                                              // marginBottom: -3,
                                              // textAlign: 'right',
                                            }
                                          }
                                          data={
                                            item.discount_conditions_document__sum_of_order
                                          }
                                          beforeText={''}
                                          // text={currencyMain && currencyMain.simbol ? currencyMain.simbol : ''}
                                          // grn={t('common:uah')}
                                        />
                                        <div
                                          style={{
                                            // width: "115px",
                                            display: 'flex',
                                            // justifyContent: "space-between"
                                          }}>
                                          <PriceToStr
                                            stSumma={{
                                              fontStyle: 'normal',
                                              fontSize: 14,
                                              fontWeight: '600',
                                            }}
                                            stAll={
                                              {
                                                // marginBottom: -3,
                                                // textAlign: 'right',
                                              }
                                            }
                                            data={item.price_with_discount}
                                            beforeText={''}
                                            text={
                                              currencyMain &&
                                              currencyMain.simbol
                                                ? currencyMain.simbol
                                                : ''
                                            }
                                            grn={t('common:uah')}
                                          />
                                          {result.prices_by_customer.other_customers.length > 0 && checkOtherCustomersList.length > 0 ? (
                                            <HtmlTooltip
                                                title={
                                                    <React.Fragment>
                                                        {renderTooltip()}
                                                    </React.Fragment>
                                                }
                                            >
                                                <div className={classes.other_customer_price}>
                                                    {otherCustomerMinPrice()} 500
                                                </div>
                                            </HtmlTooltip>
                                        ): ''

                                        }
                                          <span className={classes.slash}>
                                            /
                                          </span>
                                          <span>{t('common:pieces')}</span>
                                        </div>
                                      </div>
                                    </ListItem>
                                  ))}
                                </List>
                              </React.Fragment>
                            ) : null}
                          </>
                        ),
                      )}
                    </div>
                  </>
                  <DiscountModal
                    result={result.on_stock[0]}
                    currencyMain={currencyMain}
                    openDiscountsModal={discountsModal}
                    setDiscountsModal={setDiscountsModal}
                  />
                </Grid>
              )}
          </Grid>
          <div className={classes.footer}>
            <Grid spacing={0} container></Grid>
            <Grid spacing={0} container>
              <Grid
                item
                xs={12}
                className={clsx(
                  classes.product_input_container,
                  'product_input_container',
                )}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    lg={7}
                    xl={5}
                    className={classes.product_price_container}>
                    <Typography
                      component="h5"
                      variant="h5"
                      className={classes.totalPrice}>
                      <div className={classes.regularPriceHolder}>
                        {result.isDiscount !== 0 && (
                          <PriceToStr
                            stSumma={{
                              fontStyle: 'normal',
                              fontSize: 14,
                              fontWeight: 'normal',
                              color: '#546e7a',
                              textDecoration: 'line-through',
                            }}
                            stAll={{
                              marginBottom: -3,
                              // textAlign: 'right',
                            }}
                            data={result.on_stock[0].regularPrice}
                            beforeText={''}
                            text={
                              currencyMain && currencyMain.simbol
                                ? currencyMain.simbol
                                : ''
                            }
                            grn={t('common:uah')}
                          />
                        )}
                        {result.on_stock && currencyMain !== undefined && (
                          <PriceToStr
                            stSumma={{
                              fontStyle: 'normal',
                              color: result.isDiscount !== 0 && 'red',
                              fontSize: '24px',
                            }}
                            data={result.on_stock[0].priceCurrent}
                            beforeText={''}
                            text={
                              currencyMain && currencyMain.simbol
                                ? currencyMain.simbol
                                : ''
                            }
                            grn={t('common:uah')}
                          />
                        )}
                      </div>                   
                       
                      
                    </Typography>
                    <HtmlTooltip
                          title={
                            <React.Fragment>{renderTooltip()}</React.Fragment>
                          }>
                          <div className={classes.other_customer_price}>
                            {otherCustomerMinPrice()} пицца
                          </div>
                        </HtmlTooltip>
                  </Grid>

                  <Grid item xs={12} sm={6} md={12} lg={10} xl={7}>
                    <Button
                      disabled={!(result.countInStoks > 0)}
                      fullWidth
                      className={clsx(classes.button, 'add_to_cart')}
                      color="primary"
                      variant="contained"
                      onClick={() =>
                        setDialogData({row, indexRows: '', type: 'product'})
                      }>
                      {t('common:add_to_basket')}
                      <StyledBadgeOne
                        max={99}
                        stTop={-5}
                        stRight={-5}
                        stBackgroundColor={result.countInCart > 0 && '#2a4256'}
                        topText={
                          result.countInCart > 0 ? `${result.countInCart}` : ''
                        }
                        iconComp={
                          <BasketAdd
                            style={{
                              color: 'white',
                              marginLeft: 15,
                              marginTop: -1,
                            }}
                          />
                        }
                      />
                    </Button>
                    <p>Gfhfp</p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      )}
    </div>
  );
}
function mapState(state) {
  const {promotionsByProductsList} = state;
  return {promotionsByProductsList};
}
export default connect(mapState)(Details);
// export default Details;
